import { BaseModel, SaveType, Validations } from "@puntaje/shared/core"

export class UsuarioBaneado extends BaseModel {
    public usuario_id: number
    public fecha_inicio: Date | string
    public fecha_termino: Date | string
}
